import { Box, Stack, Typography } from '@mui/material'
import { CarrierVisitDirection } from '@planning/app/api'
import { useTranslate } from '@tolgee/react'
import { InfoIcon, useMinimalsTheme } from '@tom-ui/ui'
import { MRT_Row } from 'material-react-table'
import { RailVisitTableDto } from '../../tableConfigs/useRailVisitTableColumns'

interface RailVisitTableDetailPanelProps {
  row: MRT_Row<RailVisitTableDto>
}

export const RailVisitTableDetailPanel = ({ row }: RailVisitTableDetailPanelProps) => {
  const theme = useMinimalsTheme()
  const { t } = useTranslate()

  const item = row.original.originalRef

  const getCounts = () => {
    const discharge =
      item.getCount('total', CarrierVisitDirection.Inbound, item.data.cargoType) ||
      item.discharge.orderCounts.estimated ||
      0

    const load =
      item.getCount('total', CarrierVisitDirection.Outbound, item.data.cargoType) ||
      item.load.orderCounts.estimated ||
      0

    return { discharge, load }
  }

  const { discharge, load } = getCounts()

  const renderItem = (title: string, value?: string | number | null, fullWidth = false) => {
    if (value === undefined || value === null) return null
    return (
      <Stack minWidth={fullWidth ? '100%' : 200} mb={fullWidth ? 0 : 2}>
        <Typography variant='subtitle2' color='text.primary'>
          {title}
        </Typography>
        <Typography variant='body2' color='text.primary'>
          {value}
        </Typography>
      </Stack>
    )
  }

  return (
    <Box
      sx={{
        bgcolor: theme.palette.grey[100],
        borderTop: `1px solid ${theme.palette.divider}`,
        borderBottom: `1px solid ${theme.palette.divider}`,
        width: '100%',
      }}
    >
      <Stack direction='row'>
        <Stack
          direction='row'
          p={3}
          sx={{
            minWidth: 295,
            borderRight: `1px solid ${theme.palette.divider}`,
            bgcolor: theme.palette.grey[100],
          }}
        >
          <InfoIcon sx={{ mr: 1, color: theme.palette.text.primary }} />
          <Typography variant='subtitle2' fontWeight={600}>
            {t('additionalInformation', 'Additional information')}
          </Typography>
        </Stack>

        <Stack direction='column' p={3} width='100%'>
          <Stack direction='row' mb={2}>
            {renderItem(t('discharge', 'Discharge'), discharge)}
            {renderItem(t('load', 'Load'), load)}
          </Stack>
        </Stack>
      </Stack>
    </Box>
  )
}
